<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CelZbn/tc-custom/9781466815254.jpg?1734288160195" alt="This image is the cover for the book Deadout, Doyle Carrick"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deadout, Doyle Carrick
      </h1>
      <p class="bookDescription body article font2">
        <p> A trip to an island off the New England coast—and away from the demands of police work—might be just what is needed to jumpstart Detective Doyle Carrick and Nola Watkins' stalled relationship. But a mysterious plague is killing the island's bees. Nola takes a job at an organic farm hit hard by the disease, working for the rich, handsome, and annoying Teddy, with whom she quickly becomes a little too friendly for Doyle's liking. When Teddy's estranged father offers Doyle a big payday to keep his son out of trouble until he can close a big government contract—and when Doyle meets Annalisa, a beautiful researcher studying the bees—Doyle decides to stick around.<br/><br/> Stoma Corporation, a giant biotech company, moves in with genetically modified super bees that supposedly are the answer to the world's bee crisis. As tension grows between protestors and a private army of thugs, Doyle realizes that bees aren't the only thing being modified. Annalisa's coworkers start to go missing, and she and Doyle uncover a dark, deadly, and terrifying secret. Things spin violently out of control on the tiny island, and when Doyle closes in on what Stoma Corporation is really up to, he must race to stop them before their plot succeeds, and spreads to the mainland and the world.<br/><br/><i>Deadout </i>is the thrilling follow-up to McGoran's highly acclaimed novel, <i>Drift.</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jon McGoran
      </h2>
      
      <p class="authorDescription body article"><P>JON McGORAN is the author of <I>Deadout </I>and <I>Drift. </I>He has written about food and sustainability for twenty years, as communication director at Weavers Way Co-op in Philadelphia, and now as editor at <I>Grid</I> magazine. During that time he has also been an advocate for urban agriculture, cooperative development, and labeling of genetically engineered foods. He is a founding member of the Philadelphia Liars Club, a group of published authors dedicated to promotion, networking, and service work.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5677fccd